import * as React from 'react';
import Project from 'src/entities/Project';
import ProjectDocumentMiniatureContainer from './ProjectDocumentMiniature.container';
import DueDiligenceRequestContainer from 'src/modules/project/partials/due-diligence/DueDiligence.container';
import Person from 'src/entities/Person';
import ProjectDocument from 'src/entities/ProjectDocument';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';

interface Props {
  project: Project;
  investedUser: boolean;
  activeProfile: Person;
  companyDocument?: ProjectDocument;
  invest: boolean;
  closedProject: boolean;
}

const ProjectDocumentsComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="col-sm-9">
    <div className="padding-left-30">
      <div className="gap-50" />

      <h3>
        Documentos
      </h3>
      <div className="gap-20" />
      <div className="row">
        {
          props.project.documents.map((projectDocument) => (
            <div
              className="col-md-6 padding-20"
              key={projectDocument.id}
            >
              <ProjectDocumentMiniatureContainer projectDocument={projectDocument} />
            </div>
          ))
        }
        {props.companyDocument ?
          <div
            className="col-md-6 padding-20"
          >
            <ProjectDocumentMiniatureContainer projectDocument={props.companyDocument} />
          </div> :
          null
        }
        {props.investedUser && props.project.status === 'En financiación' ?
          <div className="col-md-6 padding-20">
            <DueDiligenceRequestContainer
              project={props.project}
              activeProfile={props.activeProfile}
            />
          </div> :
          null
        }
      </div>
      <div className="gap-20"/>
      <p className="question-detail">
        (Es posible que para poder descargar los documentos tengas que desactivar tu bloqueador de publicidad.)
      </p>
      <div className="gap-30" />
      <ProjectActionToolbarContainer
        project={props.project}
        invest={props.invest}
        closedProject={props.closedProject}
      />
      <div className="gap-50" />
    </div>
  </div>
);

export default ProjectDocumentsComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-documents/ProjectDocuments.component.tsx